import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './DockAppointments.frontend.types'

@Injectable({ providedIn: 'root' })
export class DockAppointments_get_utc_date_by_timezoneService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { dateTime: string, timezone: string }): Promise<{ utcDate?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.dateTime)) {
      missingRequiredInParams.push('\'dateTime\'');
    }
    if (isNil(inParams.timezone)) {
      missingRequiredInParams.push('\'timezone\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/functions/get_utc_date_by_timezone`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

